<template>
  <img src="/assets/images/Action-Trackchair-Logo.png" />
</template>
